export default "__VITE_ASSET__e3h$D$Ic__"